<template>
  <label class="FieldContainer">
    <div class="header">
      <div class="title">{{ title }}</div>
      <InfoTooltip v-if="info" v-bind="info" />
      <div class="annotation" v-else-if="optional">
        {{ localeStrings.optional }}
      </div>
    </div>
    <div class="inputBox">
      <slot></slot>
    </div>
    <FieldError v-if="error" v-bind="{ error }" class="error" />
  </label>
</template>

<script>
import strings from '../../data/strings.json'

import FieldError from './FieldError.vue'
import InfoTooltip from './InfoTooltip.vue'

export default {
  components: {
    FieldError,
    InfoTooltip,
  },
  inject: ['locale'],
  props: {
    title: String,
    info: Object,
    optional: Boolean,
    error: String,
  },
  computed: {
    localeStrings() {
      return strings[this.locale]
    },
  },
}
</script>

<style scoped>

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-weight: 600;
  font-size: var(--font-size-2);
  color: var(--field-title-color, var(--text-color-dark));
}

.annotation {
  font-weight: 400;
  font-size: var(--field-annotation-size, var(--font-size-0));
  color: var(--field-annotation-color, #8D8D8D);
}

.inputBox {
  margin-top: var(--spacing-0);
  display: block;
  border: thin solid #E9E9E9;
  outline: thin solid transparent;
  border-radius: 8px;
  background-color: #F9F9F9;
  transition: all 0.15s;
}

.inputBox:hover, .inputBox:focus-within {
  border-color: #B5BDC8;
  outline-color: #B5BDC8;
}

.error {
  margin-top: var(--spacing-1);
}
</style>
